
import { ref, computed } from '@vue/composition-api';
import deepmerge from 'deepmerge';
import { useStore } from '@/core/store';

export default function useGetBooking (locationId, bookingId, bookingStationTimes) {
  const store = useStore();

  const defaultBooking = {
    title: 'Walk In',
    _startNow: bookingId === 'new',
    location: {
      id: locationId,
    },
    numPlayers: 1,
    notifyHost: false,
    host: {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
    },
  };
  const bookingChanges = ref({});

  const bookingInStore = computed(() => {
    const booking = store.getters['entities/Booking'](bookingId) || {};
    return deepmerge({}, booking);
  });

  const booking = computed(() => {
    return { _id: bookingId, ...bookingInStore.value, ...bookingChanges.value, bookingStationTimes: bookingStationTimes.value };
  });

  return {
    defaultBooking,
    bookingChanges,
    bookingInStore,
    booking,
  };
}
